import { useState } from "react";
import PropTypes from "prop-types";
import { Tab } from "@headlessui/react";

import checkVideoUrlFormat from "helpers/transform-video-url";
import { Ga4WithEventParameters } from "helpers/google-tag-manager/events/ga4-with-eventparameters";

import GaleryTab from "../info-modal-tabs/galery-tab";
import VideoTab from "../info-modal-tabs/video-tab";
import ThreeDTab from "../info-modal-tabs/three-d-tab";
import MapTab from "../info-modal-tabs/map-tab";

import styles from "./styles.module.css";

const InfoModalScreenTabs = ({ tabTitles, listingDetailData, selectedModalTabReduxState, pageType, isUnitTypes }) => {
  const {
    id,
    title,
    owner: {
      account: { phoneNumber },
    },
    videoUrl,
    virtualTourUrl = null,
    imagesFullPath = [],
    location,
    url,
    flatTypes,
  } = listingDetailData;
  const [selectedIndex, setSelectedIndex] = useState(
    tabTitles.findIndex((title) => title.key === selectedModalTabReduxState) || 0
  );

  const transformedVideoUrl = checkVideoUrlFormat(videoUrl) || null;
  const isYoutubeVideo = transformedVideoUrl?.includes("youtube");

  // TO-DO: set function to transform-video-url helper.
  const getVideoPath = () => {
    if (!transformedVideoUrl?.includes("channel")) return transformedVideoUrl;
    const urlParse = new URL(transformedVideoUrl);
    const videoParams = urlParse.search.split("&");
    const videoID = (videoParams?.length > 0 && videoParams[0].replace("?v=", "")) || "";
    return `https://www.youtube.com/embed/${videoID}`;
  };

  const handleTabClick = (ga4EventLabel) => {
    Ga4WithEventParameters({
      eventName: "click_widget",
      eventParameters: { widget: `galeri||${ga4EventLabel}` },
    });
  };

  const videoTab = tabTitles.find((item) => item.key === "video");
  const threeDTab = tabTitles.find((item) => item.key === "three-d");
  const pictureTab = tabTitles.find((item) => item.key === "picture");
  const mapTab = tabTitles.find((item) => item.key === "map");

  return (
    <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
      {!isUnitTypes && (
        <Tab.List className={styles.tabList}>
          {tabTitles.map((title) => (
            <Tab
              key={title.key}
              className={({ selected }) => `${styles.tab} ${selected ? styles.tabselected : styles.tabnotselected}`}
              onClick={() => handleTabClick(title.ga4Label)}
            >
              {title.value}
            </Tab>
          ))}
        </Tab.List>
      )}
      <Tab.Panels className={styles.tabPanels}>
        {tabTitles.includes(pictureTab) && (
          <Tab.Panel className={styles.galeryTab}>
            <GaleryTab
              listingDetailData={listingDetailData}
              imagesFullPath={imagesFullPath}
              phoneNumber={phoneNumber}
              listingId={id}
              flatTypes={flatTypes}
              isUnitTypes={isUnitTypes}
              pageType={pageType}
            />
          </Tab.Panel>
        )}
        {tabTitles.includes(videoTab) && (
          <Tab.Panel className={styles.tabpanel}>
            <VideoTab title={title} videoUrl={getVideoPath()} isYoutubeVideo={isYoutubeVideo} />
          </Tab.Panel>
        )}
        {tabTitles.includes(threeDTab) && (
          <Tab.Panel className={styles.tabpanel}>
            <ThreeDTab virtualTourUrl={virtualTourUrl} />
          </Tab.Panel>
        )}
        {tabTitles.includes(mapTab) && (
          <Tab.Panel className={styles.tabpanel}>
            <MapTab location={location} listingId={id} url={url} usePoiFilterBox pageType={pageType} />
          </Tab.Panel>
        )}
      </Tab.Panels>
    </Tab.Group>
  );
};

InfoModalScreenTabs.propTypes = {
  tabTitles: PropTypes.array,
  selectedIndexTab: PropTypes.number,
  listingDetailData: PropTypes.object,
  selectedModalTabReduxState: PropTypes.string,
  pageType: PropTypes.string,
  isUnitTypes: PropTypes.bool,
};

export default InfoModalScreenTabs;
